import { TimeEntryState, TimeEntryType } from "models/TimeEntry";

export const absenceTypeToString = (type: TimeEntryType): string => {
  switch (type) {
    case 1:
      return "Sjuk";
    case 2:
      return "Betald semester";
    case 3:
      return "Vård av barn";
    case 4:
      return "Tjänstledigt";
    case 5:
      return "Övertid";
    case 6:
      return "Vård av anhörig";
    case 7:
      return "Föräldraledig";
    default:
      return "Okänd";
  }
};

export const absenceStateToString = (state: TimeEntryState): string => {
  switch (state) {
    case "PENDING":
      return "Ej attesterad";
    case "APPROVED":
      return "Godkänd";
    case "REJECTED":
      return "Nekad";
    default:
      return "Okänd";
  }
};

export const absenceTypeToColor = (type: TimeEntryType): "error" | "warning" | "success" | "info" | "primary" => {
  switch (type) {
    case 1:
      return "error";
    case 2:
      return "success";
    case 3:
      return "error";
    case 4:
      return "warning";
    case 5:
      return "info";
    case 6:
      return "error";
    case 7:
      return "warning";
    default:
      return "primary";
  }
};

export const absenceStateToColor = (state: TimeEntryState): "error" | "success" | "disabled" => {
  switch (state) {
    case "APPROVED":
      return "success";
    case "REJECTED":
      return "error";
    default:
      return "disabled";
  }
};
